import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Safely parse date strings for Safari compatibility.
 * Replaces "-" with "/" in date strings to ensure Safari can parse them.
 * Handles ISO strings correctly.
 */
export function safeDate(dateStr: string | Date | null | undefined): Date {
  if (!dateStr) return new Date();
  if (dateStr instanceof Date) return dateStr;
  
  // If it's a string, ensure it's safe for Safari
  // Safari dislikes "YYYY-MM-DD HH:mm:ss" but accepts "YYYY/MM/DD HH:mm:ss"
  // ISO strings "YYYY-MM-DDTHH:mm:ss.sssZ" are usually fine, but replacing - with / is a common catch-all fix for non-ISO
  // However, we shouldn't break ISO strings. 
  // A safer check: if it contains "T", assume ISO and leave it (Safari supports ISO).
  // If it doesn't contain "T" but has dashes, replace them.
  
  if (typeof dateStr === 'string') {
      if (!dateStr.includes('T') && dateStr.includes('-')) {
          return new Date(dateStr.replace(/-/g, '/'));
      }
  }
  
  return new Date(dateStr);
}
